module.exports = __webpack_public_path__ + "img/consult_info10.18956d5e.png";